import Api from './api'

const resource = '/profile'
export default {
  update(data) {
    return Api.patch(`${resource}/update`, data)
  },
  destroy() {
    return Api.delete(`${resource}/destroy`)
  },
  avatar(data) {
    let formData = new FormData();
    if (data.avatar) formData.append('avatar', data.avatar);
    return Api.post(`${resource}/avatar`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
